import React from "react";

import { ToggleButtons } from "@aclymatepackages/atoms";

const fuelTypeButtons = [
  { name: "Natural Gas", value: "naturalGas" },
  { name: "Propane", value: "propane" },
  { name: "Wood", value: "wood" },
  { name: "Heating Oil", value: "heatingOil" },
];

const FuelTypeToggleButtons = ({
  value,
  onChange,
  size = "small",
  disabled = false,
}) => (
  <ToggleButtons
    buttons={fuelTypeButtons}
    value={value}
    onChange={onChange}
    size={size}
    disabled={disabled}
  />
);

export default FuelTypeToggleButtons;
